import { getStaticAsset } from "core/model/config";
import LinkV2, { LinkV2Props } from "ds_legacy/components/LinkV2";
import React, { forwardRef } from "react";

type BaseImageProps = {
  alt: string;
  linkProps?: LinkV2Props;
  style?: React.CSSProperties;
  testId?: string;
  width?: React.CSSProperties["width"];
  className?: string;
};

type ImagePropsWithSrc = BaseImageProps & {
  path?: never;
  src: string;
};

type ImagePropsWithPath = BaseImageProps & {
  path: string;
  src?: never;
};

export const Image = forwardRef<
  HTMLImageElement,
  ImagePropsWithSrc | ImagePropsWithPath
>(({ alt, linkProps, path, src, style, testId, width, ...rest }, ref) => {
  const imageUrl = src ? src : getStaticAsset(path as string);

  const Img = ({ imageTestId }: { imageTestId?: string }) => (
    <img
      ref={ref}
      alt={alt}
      data-testid={imageTestId}
      src={imageUrl}
      style={{ ...style, objectFit: "contain" }}
      width={width}
      {...rest}
    />
  );

  if (linkProps) {
    return (
      <LinkV2 data-testid={testId} {...linkProps}>
        <Img />
      </LinkV2>
    );
  }

  return <Img imageTestId={testId} />;
});

export default Image;
